var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddressPin = function SvgAddressPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    fill: "none",
    viewBox: "0 0 12 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M0 0h11.162v11.163H4.837L0 16z"
  })));
};
export default SvgAddressPin;